import { render, staticRenderFns } from "./AdminSettingsMailServer.vue?vue&type=template&id=00225831"
import script from "./AdminSettingsMailServer.vue?vue&type=script&setup=true&lang=ts"
export * from "./AdminSettingsMailServer.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./AdminSettingsMailServer.vue?vue&type=style&index=0&id=00225831&prod&module=true&lang=css"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports